import { request } from '../utils';
import { URL } from './constants';

export function legacyUrlRequest(apiUrl) {
  var options = {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'text/plain'
    }),
    credentials: 'include'
  };
  return request(URL(apiUrl), options, true);
}

export default legacyUrlRequest;